export default __webpack_public_path__ + "static/media/problema-07.64a6d7bb.webp";